import Modal from '@/components/modals/modal/modal.vue'

export default {
  name: 'ShowNoteModal',
  components: {
    Modal
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    modalError: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    show () {
      this.$refs.modal.show()
    },
    hide () {
      this.$refs.modal.hide()
    }
  }
}